var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:(_vm.levelViewStyle),attrs:{"id":"level-view"}},[_c('Level',{key:_vm.selectedLevelString,attrs:{"levelId":_vm.selectedLevelString,"mapConfig":_vm.mapConfig}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }